import React from "react";
import { useTranslation } from "react-i18next";
import LifestyleUseCases from "../LifestyleUseCases";
import { useSmartBandLifestyleData } from "./smartBandData";

const LifestyleUseCasesSmartBand: React.FC = () => {
    const { t } = useTranslation("bandLifestyle");
    const smartBandLifestyleData = useSmartBandLifestyleData();

    return (
        <LifestyleUseCases
            data={smartBandLifestyleData}
            sectionTitle={{
                regularText: t("sectionTitle.regularText"),
                highlightedText: t("sectionTitle.highlightedText"),
                descriptionHighlight: t("sectionTitle.descriptionHighlight"),
                descriptionText: t("sectionTitle.descriptionText"),
            }}
            className="smartband-lifestyle-section"
        />
    );
};

export default LifestyleUseCasesSmartBand;
